export default __webpack_public_path__ + "static/media/AR-3.93d5e53a.jpg";